/**
 * Inicio del modo Hunting (búsqueda proactiva de candidatos en Apollo.io).
 * PLAN_HUNTING_APOLLO.md §5.4 / §9 — MVP: texto de bienvenida, cómo funciona
 * y el acceso a "Nueva búsqueda". Las métricas (búsquedas, contactados,
 * créditos) llegan con el historial (fase D).
 */
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import {
  TravelExplore as SearchIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useStore from '../config/store';
import { DEFAULT_PRICING, fmtPoints } from './huntingPricing';

const HuntingHomeLayout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, projectName } = useStore.getState();
  const userName = user?.name || user?.displayName || '';

  // Precios con el valor calculado (2026-10-22): 0.06 por email, 0.50 por teléfono
  const prices = { emailPoints: fmtPoints(DEFAULT_PRICING.email), phonePoints: fmtPoints(DEFAULT_PRICING.phone) };
  const steps = [1, 2, 3, 4, 5].map((n) => t(`hunting.home.howItWorks.step${n}`, prices));

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700}>
          {userName ? t('hunting.home.welcomeName', { name: userName }) : t('hunting.home.welcome')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {t('hunting.home.subtitle')}{projectName ? ` — ${projectName}` : ''}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 4 }}>
        <Button
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => navigate('/hunting/search')}
          sx={{ backgroundColor: '#6A5AF9', '&:hover': { backgroundColor: '#5B4DE8' } }}
        >
          {t('hunting.home.actions.newSearch')}
        </Button>
      </Box>

      <Card elevation={0} sx={{ border: '1px solid #E5E7EB', borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
            {t('hunting.home.howItWorks.title')}
          </Typography>
          <Box component="ol" sx={{ pl: 2.5, m: 0, '& li': { mb: 1 } }}>
            {steps.map((step, idx) => (
              <Typography component="li" variant="body2" key={idx}>{step}</Typography>
            ))}
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
            {t('hunting.home.howItWorks.creditsNote')}
          </Typography>
          <Button
            size="small"
            endIcon={<ArrowForwardIcon />}
            onClick={() => navigate('/hunting/search')}
            sx={{ mt: 2, color: '#6A5AF9' }}
          >
            {t('hunting.home.actions.newSearch')}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default HuntingHomeLayout;
